<mat-toolbar id="header"  tourAnchor="boardTour" >
    <img *ngIf="isUserLoggedIn" src="assets/images/svg/newlogo.svg" class="logoLeft" routerLink="/u" height="50px"  alt="">
    <img *ngIf="!isUserLoggedIn" src="assets/images/svg/newlogo.svg" class="logoLeft" routerLink="/" height="50px"  alt="">
    <app-searchbox></app-searchbox>
    <span class="example-spacer"></span>

    <div class="profilImageOnMenu" *ngIf="isUserLoggedIn && local_newfollow_count + local_newComment_count + local_newUserRelation_count != 0"  >
        <div class="profilImageMenu" matBadge="{{local_newfollow_count + local_newComment_count + local_newUserRelation_count}}" matBadgeSize="small" matBadgeColor="accent" [matMenuTriggerFor]="menuDashboard" [ngStyle]="{'background': 'linear-gradient(0deg, rgba(0, 0, 0, 0.0),
        rgba(0, 0, 0, 0.0)), url(' + getCurrentUserLiveRequest.user_avatar + ')
        center center / cover no-repeat'}">
        <mat-icon  id="verifiedIconSizeHeader" *ngIf="getCurrentUserLiveRequest.user_is_verified"> verified</mat-icon>
        </div>
    </div>
    <div class="profilImageOnMenu" *ngIf="isUserLoggedIn && local_newfollow_count + local_newComment_count + local_newUserRelation_count == 0"  >
        <div class="profilImageMenu" [matMenuTriggerFor]="menuDashboard" [ngStyle]="{'background': 'linear-gradient(0deg, rgba(0, 0, 0, 0.0),
        rgba(0, 0, 0, 0.0)), url(' + getCurrentUserLiveRequest.user_avatar + ')
        center center / cover no-repeat'}">
        <mat-icon  id="verifiedIconSizeHeader" *ngIf="getCurrentUserLiveRequest.user_is_verified"> verified</mat-icon>
        </div>
    </div>
    <!-- <button mat-icon-button [matMenuTriggerFor]="menuStatsite" *ngIf="!isUserLoggedIn" >
        <mat-icon routerLinkActive="aktivLink" class="iconMenu">menu</mat-icon>
    </button> -->
    <button mat-icon-button routerLink="/login" class="loginInOrOut" *ngIf="!isUserLoggedIn" >
        <mat-icon routerLinkActive="aktivLink" class="iconWhite">power_settings_new</mat-icon>
    </button>
</mat-toolbar>
<!-- <mat-menu #menuStatsite="matMenu" class="menuContentStartsite"  >
    <div class="menuButton"  *ngFor="let linksforFooter of tilesNonLoggedInn">
        <div class="menuItem" align="right" routerLink="{{linksforFooter.link}}" >
            <div class="menuText" >
                &nbsp;
                &nbsp;
                &nbsp;
{{ linksforFooter.text | translate }} <span class="mdi mdi-{{linksforFooter.icon}}"></span>
            </div>

        </div>
    </div>
</mat-menu> -->
<mat-menu #menuDashboard="matMenu" class="menuContent"  >
    <div class="menuButton"  *ngFor="let linksforFooter of tilesDashboard">
        <div class="menuItem" align="right"  >
            <div class="menuText" *ngIf="linksforFooter.text == 'keyword_$119' && local_newfollow_count + local_newComment_count + local_newUserRelation_count != 0" routerLink="{{linksforFooter.link}}">
                &nbsp;
                &nbsp;
                &nbsp;{{ linksforFooter.text | translate }} <span class="mdi mdi-{{linksforFooter.icon}}" matBadge="{{local_newfollow_count + local_newComment_count + local_newUserRelation_count}}" matBadgeSize="small" matBadgeColor="accent"></span>
            </div>
            <div class="menuText" *ngIf="linksforFooter.text == 'keyword_$119' && local_newfollow_count + local_newComment_count + local_newUserRelation_count == 0" routerLink="{{linksforFooter.link}}">
                &nbsp;
                &nbsp;
                &nbsp;{{ linksforFooter.text | translate }} <span class="mdi mdi-bell-outline"></span>
            </div>
            <div class="menuText" *ngIf="linksforFooter.text == 'keyword_$464' && local_newMsg_count != 0" routerLink="{{linksforFooter.link}}">
                &nbsp;
                &nbsp;
                &nbsp;{{ linksforFooter.text | translate }} <span class="mdi mdi-{{linksforFooter.icon}}" matBadge="{{local_newMsg_count}}" matBadgeSize="small" matBadgeColor="accent"></span>
            </div>
            <div class="menuText" *ngIf="linksforFooter.text == 'keyword_$464' && local_newMsg_count == 0" routerLink="{{linksforFooter.link}}">
                &nbsp;
                &nbsp;
                &nbsp;{{ linksforFooter.text | translate }} <span class="mdi mdi-email-outline"></span>
            </div>
            <div class="menuText" *ngIf="linksforFooter.text == 'keyword_$126'" routerLink="/p/{{getCurrentUserLiveRequest.user_name}}">
                &nbsp;
                &nbsp;
                &nbsp;{{ linksforFooter.text | translate }} <span class="mdi mdi-{{linksforFooter.icon}}" ></span>
            </div>
            <div class="menuText" *ngIf="linksforFooter.text != 'keyword_$119' && linksforFooter.text != 'keyword_$126' && linksforFooter.text != 'keyword_$464'" routerLink="{{linksforFooter.link}}" >
                &nbsp;
                &nbsp;
                &nbsp;{{ linksforFooter.text | translate }} <span class="mdi mdi-{{linksforFooter.icon}}"></span>
            </div>
        </div>
    </div>
</mat-menu>
